export default __webpack_public_path__ + "static/media/ezgif.com-gif-maker.40289ede.gif";